import React from 'react';
import AppBar from '@material-ui/core/AppBar';
// import Button from '@material-ui/core/Button';
// import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
// import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
// import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
// import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
// import Container from '@material-ui/core/Container';
import BusinessIcon from '@material-ui/icons/Business';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import { Language, Android, Apple, Business, ShoppingCart } from "@mui/icons-material";
import { Container, Grid, Card, CardContent, Typography, Button } from "@mui/material";


const useStyles = makeStyles((theme) => ({
   
    heroContent: {
        marginBottom: theme.spacing(2),
        color: '#00695c',
    },
    external: {
        color: '#E53935'
      },
      button: {
        backgroundColor: '#303F9F',
        color: '#ffffff',
        "&:hover": {
            backgroundColor: '#ffffff',
            color: '#303F9F',
        }
      },
  
    
}));


export default function RetailSite() {
    const classes = useStyles();

    return (
        <React.Fragment>
            {/* Hero unit */}
        <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h5" align="center" gutterBottom>
        Explore Our Tea Platforms
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {/* Auction Website */}
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ textAlign: "center", p: 2, borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Language fontSize="large" color="primary" />
              <Typography variant="subtitle1" gutterBottom>
                Auction Website
              </Typography>
              <Button
                href="https://auction.genexports.com"
                variant="outlined"
                size="small"
              >
                Visit
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Android App */}
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ textAlign: "center", p: 2, borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Android fontSize="large" color="success" />
              <Typography variant="subtitle1" gutterBottom>
                Android App
              </Typography>
              <Button
                href="https://play.google.com/store/apps/details?id=com.genexports.teaauction"
                variant="outlined"
                size="small"
              >
                Download
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* iOS App */}
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ textAlign: "center", p: 2, borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Apple fontSize="large" color="action" />
              <Typography variant="subtitle1" gutterBottom>
                iOS App
              </Typography>
              <Button
                href="https://apps.apple.com/in/app/tea-auction/id6740537362"
                variant="outlined"
                size="small"
              >
                Download
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* B2B Site */}
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ textAlign: "center", p: 2, borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <ShoppingCart fontSize="large" color="primary" />
              <Typography variant="subtitle1" gutterBottom>
                B2B Site
              </Typography>
              <Button
                href="https://teashop.genexports.com"
                variant="outlined"
                size="small"
              >
                Visit
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
        </React.Fragment>
    );
}